module.exports = __webpack_public_path__ + "static/media/guest.2691b75c.png";